import { observer } from 'mobx-react-lite'
import { Icon, Switch, Tooltip, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type ICreateContactWithSwitchProps = {
  integrationName: string
  sendFromLeadOwner: boolean
  handleSendFromLeadOwnerToggle: () => void
}

export const CreateContactWithSwitch = observer(
  ({
    integrationName,
    sendFromLeadOwner,
    handleSendFromLeadOwnerToggle,
  }: ICreateContactWithSwitchProps) => {
    return (
      <>
        <Typography ariaLabel={'label'} variant={'body-md-medium'} className={styles.sectionLabel}>
          Create Contact on Contact Owner
          <Tooltip
            label={`By turning this toggle on, the contact will be assigned to its owner on  ${integrationName}. If off, the contact will be assigned to you.`}
            breakWord={true}
            placement={'top'}
            width={250}
          >
            <Icon fontSize={14} icon={'question'} color={'var(--content-neutral-primary)'} />
          </Tooltip>
        </Typography>

        <Switch
          className={styles.rowSwitch}
          size='middle'
          value={sendFromLeadOwner}
          onChange={handleSendFromLeadOwnerToggle}
        />
      </>
    )
  }
)
